import React from 'react';
import EmailView from './EmailView';
import ChatView from './ChatView';
import VoiceView from './VoiceView';
import TaskView from './TaskView';
import NoData from './NoData';
import { Spinner } from '@chakra-ui/react';

function MediaPanel({ mediaBody, mediaLoading, selectedMediaType, selectedItem }) {
    if (mediaLoading) {
        return (
            <Spinner
                thickness="15px"
                speed="0.65s"
                color="green.200"
                h="240px"
                w="240px"
                mt="30%"
            />
        );
    }
    if (selectedItem === '') {
        return (
            <NoData data={{heading: 'Choose an Interaction', subtitle: 'Search for and select an interaction to view the associated media.'}}/>
        );
    }

    switch (selectedMediaType) {
        case 'EMAIL':
            if (mediaBody !== '') {
                return <EmailView data={mediaBody} />;
            }
            break;
        case 'WEBCHAT':
            if (mediaBody !== '') {
                return <ChatView data={mediaBody} />;
            }
            break;
        case 'SMS':
            if (mediaBody !== '') {
                return <ChatView data={mediaBody} />;
            }
            break;
        case 'VOICE':
            if (mediaBody !== '') {
                return <VoiceView data={mediaBody} />;
            }
            break;
        case 'TASK':
                if (mediaBody !== '') {
                    return <TaskView data={mediaBody} />;
                }
                break;
        default:
            return <NoData data={{heading: 'No Media to Display', subtitle: 'Sorry. There is no media file available for this interaction.'}}/>;
    }

    // Fallback (covers the scenario where mediaBody is an empty string)
    return <NoData data={{heading: 'No Media to Display', subtitle: 'Sorry. There is no media file available for this interaction.'}}/>
}

export default MediaPanel;
